var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":'module-image-' + _vm.dModule.id}},[(_vm.dModule.data.redirect)?_c('a',{attrs:{"href":_vm.dModule.data.redirectTarget,"target":_vm.dModule.data.redirectType}},[_c('img',{staticClass:"responsive",attrs:{"src":_vm.dModule.data.image}})]):_c('img',{staticClass:"responsive",attrs:{"src":_vm.dModule.data.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }